// Annotation Portal React UI for Guidelines

import { useState } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Guidelines from "./modals/guidelines";
import { useTranslation } from "hooks/useTranslation";

function ManageSuper_Admin() {
  const { t } = useTranslation();
  const [openGuidelines, setOpenGuidelines] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Card
          sx={{
            boxShadow: 4,
            borderRadius: 2,
            overflow: "hidden",
            backgroundColor: "#f9fafe",
            border: "1px solid #e0e0e0",
          }}
        >
          <Guidelines open={openGuidelines} onClose={() => setOpenGuidelines(false)} />
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ManageSuper_Admin;
